import { render, staticRenderFns } from "./infosetsOverviewLabelsSkeleton.vue?vue&type=template&id=f78b7db0&"
import script from "./infosetsOverviewLabelsSkeleton.vue?vue&type=script&lang=ts&"
export * from "./infosetsOverviewLabelsSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports